import * as array from './array';
import * as object from './object';
import * as string from './string';
import * as uuid from './uuid';

export default {
  array,
  object,
  string,
  uuid,
};
